import styled from 'styled-components';
import { media, Row } from '@simplywallst/ui-core';

import { sectionHeading } from '../../styled';

export const StoryContainerRow = styled(Row)`
  width: 100%;
`;

export const StoryHeader = styled.div`
  margin: ${({ theme }) => theme.x4spacePx}px
    ${({ theme }) => theme.x2spacePx}px;
  ${media.lgUp`
    margin: ${({ theme }) => theme.x7spacePx}px;
  `}
  text-align: center;
  h2 {
    ${sectionHeading}
  }
`;

export const StoryContentRow = styled(Row)`
  margin: ${({ theme }) => theme.x2spacePx}px;
  ${media.lgUp`
     margin: ${({ theme }) => theme.x8spacePx}px 0 0;
  `}
`;

export const StoryContentText = styled(Row)`
  ${media.mdOnly`
    width: 90%;
  `}
`;

export const StyledStoryContentReactMarkdown = styled('div')`
  position: relative;
  margin-bottom: ${({ theme }) => theme.x4spacePx}px;
  ${media.lgUp`
    margin: 0 ${({ theme }) => theme.x13spacePx}px ${({ theme }) =>
      theme.x5spacePx}px;
  `};
  h4 {
    ${({ theme }) => theme.typography.heroStrong};
    font-weight: 700;
    color: ${({ theme }) => theme.color.spaceGray};
    margin: 0 0 ${({ theme }) => theme.x1spacePx}px;
    letter-spacing: -0.02em;
    ${media.mdUp`
        margin-top: 0;
        margin-bottom: ${({ theme }) => theme.x2spacePx}px;
    `};
  }
  p {
    ${({ theme }) => theme.typography.large};
    color: ${({ theme }) => theme.color.spaceGray};
    margin-bottom: 0;
  }
  img {
    height: 300px;
    object-fit: cover;
    object-position: 30% 100%;
    border-radius: 20px;
    margin: ${({ theme }) => theme.x2spacePx}px 0;
    ${media.mdUp`
      width: 100%;
      margin-bottom: ${({ theme }) => theme.x1spacePx}px;
    `};
  }
  strong:first-of-type {
    position: absolute;
    right: 25px;
    top: 25%;
    color: #fff;
    ${media.lgUp`
      right: 45px;
      top: 35%;
    `};
  }
  em:first-of-type {
    position: absolute;
    right: 30px;
    top: 30%;
    color: #fff;
    ${({ theme }) => theme.typography.tiny};
    font-style: normal;
    ${media.lgUp`
      right: 55px;
      top: 40%;
    `};
  }
`;

export const TimelineHeader = styled.h4`
  ${({ theme }) => theme.typography.smallStrong};
  color: ${({ theme }) => theme.color.spaceGray};
  font-weight: 700;
  margin-bottom: 54px;
  margin-top: ${({ theme }) => theme.x2spacePx}px;
`;

export const Timeline = styled.div`
  ${({ theme }) => theme.typography.xLargeStrong};
  color: ${({ theme }) => theme.color.spaceGray};
  position: relative;
  width: 100%;
  margin: 0 auto;

  :after {
    content: '';
    position: absolute;
    width: 1px;
    background: ${({ theme }) => theme.color.brand03};
    top: -30px;
    bottom: 0;
    left: 55px;
    opacity: 0.2;
  }
`;

export const StyledTimelineContentReactMarkdown = styled('div')`
  li {
    ${({ theme }) => theme.typography.smallStrong};
    font-weight: 700;
    margin-bottom: 58px;
    margin-left: ${({ theme }) => theme.x3spacePx}px;
    ${media.mdUp`
      margin-left: ${({ theme }) => theme.x1spacePx}px;
    `};
    ${media.mdOnly`
      margin-left: ${({ theme }) => theme.x4spacePx}px;
    `};
  }
`;

export const StyledDateReactMarkdown = styled('div')`
  li {
    ${({ theme }) => theme.typography.small};
    margin-bottom: 58px;
    position: relative;

    :after {
      content: '';
      position: absolute;
      width: 8px;
      height: 8px;
      left: 55px;
      top: 8px;
      margin: -3px;
      background: ${({ theme }) => theme.color.brand03};
      border-radius: 50%;
      z-index: 1;
    }
  }
`;
